/**
 * @generated SignedSource<<3a21ac989944268c0bc68ac9c0b61df4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem$data = {
  readonly sku: {
    readonly _id: string;
    readonly name: string;
    readonly images: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly url: string;
        };
      }>;
    };
  };
  readonly " $fragmentType": "AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem";
};
export type AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem$key = {
  readonly " $data"?: AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSku",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuImageConnection",
          "kind": "LinkedField",
          "name": "images",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuImageEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSkuImage",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuAssemblyItemCompositionItem",
  "abstractKey": null
};

(node as any).hash = "7827a9daa14eb8fc6ce52079e79bbef9";

export default node;
